<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
       <span
           class="main-r_top_nav"
           :class="mainStatus === 'online' && 'active'"
           @click.stop="handleClick('online')"
       >{{$t('apiDoc.在线文档')}}</span>
      <span
          class="main-r_top_nav"
          :class="mainStatus === 'apiTest' && 'active'"
          @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'bill/lading/bind';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.下发清关小包信息接口（运单号需要先从订单创建接口获取）')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList:[
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
              {name: "timestamp",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳')}`,},
              {name: "digest",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
              {name: "digestType",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.签名类型')}`, },
            ]
          },
          {
            title:`${this.$t('onlineDoc.请求参数')}`,
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: '',describe: `${this.$t('onlineDoc.业务参数')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.业务参数')}`,
            value:[
              {name: "billCode",type: "String(50)",require: "Y", normal: "", describe:`${this.$t('onlineDoc.运单号')}`},
              {name: "txlogisticId",type: "String(50)",require: "Y", describe:`${this.$t('onlineDoc.客户订单号（包裹号）')}`},
              {name: "receiverName",type: "String(30)",require: "Y", describe:`${this.$t('onlineDoc.收件人名称')}`},
              {name: "receiverCountry",type: "String",require: "Y", describe:`${this.$t('onlineDoc.收件国家')}`},
              {name: "receiverZip",type: "String",require: "N", describe:`${this.$t('onlineDoc.收件邮编')}`},
              {name: "receiverAddress",type: "String(200)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件人详细地址')}`},
              {name: "receiverMobile",type: "String(30)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件人手机号')}`},
              {name: "receiverPhone",type: "String(30)",require: "N",normal: "",describe:`${this.$t('onlineDoc.收件人电话')}`},
              {name: "receiverIdNumber",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.收件人ID信息')}`},
              {name: "receiverIdExpiryDate",type: "String",require: "N",normal: "YYYY-MM-DD，2024-03-01",describe:`${this.$t('onlineDoc.收件人ID有效截止日期')}`},
              {name: "receiverBirthDay",type: "String",require: "N",normal: "YYYY-MM-DD，2024-03-01",describe:`${this.$t('onlineDoc.收件人生日')}`},
              {name: "receiverNationality",type: "String",require: "N",normal: "KSA",describe:`${this.$t('onlineDoc.收件人国籍')}`},
              {name: "senderZip",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件邮编')}`},
              {name: "senderName",type: "String(30)",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件人名称')}`},
              {name: "senderCountry",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.寄件国家')}`},
              {name: "senderAddress",type: "String(200)",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件人详细地址')}`},
              {name: "senderMobile",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件人手机号')}`},
              {name: "senderPhone",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件人电话')}`},
              {name: "senderCompany",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件公司')}`},
              {name: "reportingCurrency",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.申报币种')}`},
              {name: "packageWeight",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.包裹重量')}`},
              {name: "itemList",type: "Object",require: "Y",normal: "",describe:`${this.$t('onlineDoc.物品明细')}`},
            ],
          },
          {
            title:`${this.$t('onlineDoc.itemList类型说明')}`,
            value:[
              {name: "chineseName",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.物品中文名称')}`},
              {name: "englishName",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.物品英文名称')}`},
              {name: "quantity",type: "Integer",require: "Y",normal: "",describe:`${this.$t('onlineDoc.数量')}`},
              {name: "unitPrice",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.物品单价')}`},
              {name: "unitWeight",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.物品单重（单个物品的重量）')}`},
              {name: "itemDescription",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.物品描述')}`},
              {name: "hscode",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.海关申报编码')}`},
              {name: "categoryId",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.类目id')}`},
              {name: "sku",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.sku')}`}
            ]
          },
        ],
        responseDataList:[
          {
            title:`${this.$t('onlineDoc.响应参数')}`,
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码')}`,},
              {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
              {name: "data",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.data类型说明')}`,
            value:[
              {name: "operationResults",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.操作结果,1请求成功，0失败')}`,},
              {name: "billCode",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`,},
              {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号（包裹号）')}`,},
              {name: "errorDescription",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.错误描述')}`,},
              {name: "errorCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.错误码')}`,}
            ]
          }

        ],
        //请求示例
        requestCode: `Header：
     apiAccount=292508153084379141
     Content-Type=application/x-www-form-urlencoded
     digest=djEINdkT7aLeivrvhf91SQ==
     timestamp=1648536570679

 Body：
    bizContent = {"receiverIdExpiryDate":"2026-12-31","receiverBirthDay":"1985-08-20","senderAddress":"Pudong New Area","reportingCurrency":"SAR","senderCompany":"Shanghai International Trade Co., Ltd.","receiverName":"Mohammed Al-Saud","packageWeight":"3.75","senderZip":"200000","receiverMobile":"+966501234567","customerCode":"J0086024173","senderMobile":"+8613912345678","receiverNationality":"KSA","billCode":"UTE019033821108","receiverIdNumber":"1101234567","txlogisticId":"TX2025432294171","receiverAddress":"King Fahd Road, Riyadh 12345, Saudi Arabia","senderPhone":"+862168888888","senderName":"王小明","receiverCountry":"AE","receiverPhone":"+966112345678","itemList":[{"unitPrice":"148.84","unitWeight":"0.15","englishName":"Men's T-Shirt","quantity":2,"hscode":"6109100000","chineseName":"男士T恤","itemDescription":"Pure cotton men's casual T-shirt","sku":"TSHIRT_M_COTTON_BLACK_M","categoryId":"CAT_CLOTHING_001"}],"senderCountry":"CN","receiverZip":"12345"}`,
        //返回示例
        responseCode: JSON.parse(`{
  "code": "1",
  "msg": "success",
  "data": {
    "operationResults": "1",
    "billCode": "UTE019033821108",
    "txlogisticId": "TX2025432294171"
  }
}`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "292508153084379141",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data:{
          bizContent: `{"receiverIdExpiryDate":"2026-12-31","receiverBirthDay":"1985-08-20","senderAddress":"Pudong New Area","reportingCurrency":"SAR","senderCompany":"Shanghai International Trade Co., Ltd.","receiverName":"Mohammed Al-Saud","packageWeight":"3.75","senderZip":"200000","receiverMobile":"+966501234567","customerCode":"J0086024173","senderMobile":"+8613912345678","receiverNationality":"KSA","billCode":"UTE019033821108","receiverIdNumber":"1101234567","txlogisticId":"TX2025432294171","receiverAddress":"King Fahd Road, Riyadh 12345, Saudi Arabia","senderPhone":"+862168888888","senderName":"王小明","receiverCountry":"AE","receiverPhone":"+966112345678","itemList":[{"unitPrice":"148.84","unitWeight":"0.15","englishName":"Men's T-Shirt","quantity":2,"hscode":"6109100000","chineseName":"男士T恤","itemDescription":"Pure cotton men's casual T-shirt","sku":"TSHIRT_M_COTTON_BLACK_M","categoryId":"CAT_CLOTHING_001"}],"senderCountry":"CN","receiverZip":"12345"}`,
        },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>